import { render, staticRenderFns } from "./attribute-filter.vue?vue&type=template&id=07736659"
import script from "./attribute-filter.vue?vue&type=script&lang=js"
export * from "./attribute-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports